import { ContainerTile, ContainerTileConfig } from '../components/container-tile.js';

export class HomePage {
  private container: HTMLElement;
  private tiles: ContainerTile[] = [];

  constructor() {
    this.container = this.createContainer();
    this.createTiles();
  }

  private createContainer(): HTMLElement {
    const container = document.createElement('div');
    container.className = 'home-page';
    container.style.cssText = `
      padding: var(--spacing-xl);
      display: flex;
      flex-direction: column;
      align-items: center;
      min-height: calc(100vh - 100px);
    `;

    // Create subtitle section
    const subtitle = this.createSubtitle();
    container.appendChild(subtitle);

    // Create tiles container
    const tilesContainer = this.createTilesContainer();
    container.appendChild(tilesContainer);

    return container;
  }

  private createSubtitle(): HTMLElement {
    const subtitleSection = document.createElement('div');
    subtitleSection.className = 'home-subtitle';
    subtitleSection.style.cssText = `
      text-align: center;
      margin-bottom: var(--spacing-xl);
    `;

    const subtitle = document.createElement('p');
    subtitle.textContent = 'Select a container to browse and view PDFs';
    subtitle.style.cssText = `
      color: var(--text-secondary);
      font-size: 1.1rem;
      margin: 0;
    `;

    subtitleSection.appendChild(subtitle);

    return subtitleSection;
  }

  private createTilesContainer(): HTMLElement {
    const tilesContainer = document.createElement('div');
    tilesContainer.className = 'tiles-container';

    return tilesContainer;
  }

  private createTiles(): void {
    const containerConfigs: ContainerTileConfig[] = [
      {
        id: 'pdf1',
        title: 'Blechstrasse 1',
        description: 'Browse and view PDFs from the Blechstrasse 1',
        icon: '🗂️',
        color: 'var(--primary-color)',
        route: '/pdf1'
      },
      {
        id: 'pdf2',
        title: 'Blechstrasse 2',
        description: 'Browse and view PDFs from the Blechstrasse 2',
        icon: '🗂️',
        color: 'var(--primary-color)',
        route: '/pdf2'
      },
      {
        id: 'pdf3',
        title: 'Blechstrasse 3',
        description: 'Browse and view PDFs from the Blechstrasse 3',
        icon: '🗂️',
        color: 'var(--primary-color)',
        route: '/pdf3'
      },
      {
        id: 'pdf4',
        title: 'Blechstrasse 4',
        description: 'Browse and view PDFs from the Blechstrasse 4',
        icon: '🗂️',
        color: 'var(--primary-color)',
        route: '/pdf4'
      },
      {
        id: 'pdf5',
        title: 'Biegezentrum Schröder',
        description: 'Browse and view PDFs from the Biegezentrum Schröder',
        icon: '🗂️',
        color: 'var(--primary-color)',
        route: '/pdf5'
      },
      {
        id: 'pdf6',
        title: 'Türenpressen',
        description: 'Browse and view PDFs from the Türenpressen',
        icon: '🗂️',
        color: 'var(--primary-color)',
        route: '/pdf6'
      },
      {
        id: 'pdf7',
        title: 'Zuschnitte',
        description: 'Browse and view PDFs from the Zuschnitte',
        icon: '🗂️',
        color: 'var(--primary-color)',
        route: '/pdf7'
      }
    ];

    const tilesContainer = this.container.querySelector('.tiles-container') as HTMLElement;
    
    containerConfigs.forEach(config => {
      const tile = new ContainerTile(config);
      this.tiles.push(tile);
      tilesContainer.appendChild(tile.getElement());
    });
  }

  public mount(target: HTMLElement): void {
    // Hide the initial loading state
    const initialLoading = document.getElementById('initial-loading');
    if (initialLoading) {
      initialLoading.style.display = 'none';
    }
    
    // Mount the home page content to the main-content area
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.innerHTML = '';
      mainContent.appendChild(this.container);
    } else {
      // Fallback to the passed target
      target.innerHTML = '';
      target.appendChild(this.container);
    }
  }

  public destroy(): void {
    this.tiles.forEach(tile => tile.destroy());
    this.tiles = [];
    this.container.remove();
  }
}
